import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { loadReminderPreferences } from '../../actions/settings';
import Tier from '../../constants/tiers';
import PremiumGate from '../PremiumGate';
import ReminderPreferencesForm from './ReminderPreferencesForm';

function mapStateToProps(state) {
  return {
    settingsInfo: state.settingsInfo,
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadReminderPreferences: () => dispatch(loadReminderPreferences()),
  };
}

class Settings extends Component {
  componentDidMount() {
    this.props.loadReminderPreferences();
  }

  render() {
    const isPremium = this.props.userInfo && this.props.userInfo.tier === Tier.PREMIUM;
    const { loaded, reminderPreferences } = this.props.settingsInfo;

    return (
      <Container>
        <Row>
          <Col><h2>Settings</h2></Col>
        </Row>
        <Row>
          <Col>
            <h5>Reminder Emails</h5>
            {!isPremium && (
              <PremiumGate message="Upgrade to Premium to set up reminder emails." />
            )}
            {isPremium && !loaded && (
              <Spinner animation="border" size="sm" />
            )}
            {isPremium && loaded && (
              <ReminderPreferencesForm reminderPreferences={reminderPreferences} />
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
